module.exports = new __parcel__URL__("orange-icon.10656dd1.png").toString();